"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var React = require("react");
require("./Dropdown.scss");
var classnames_1 = require("classnames");
require("../../resources/icons/style.css");
var Dropdown = function (props) {
    var _a, _b;
    var name = props.name, register = props.register;
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    var _d = React.useState((_a = props.initialSelection) !== null && _a !== void 0 ? _a : -1), selection = _d[0], setSelection = _d[1];
    var selectedLabel = selection < 0 ? props.placeholder : props.children[selection].props.label;
    var handleClick = function (event) {
        if (props.disabled) {
            return;
        }
        event.stopPropagation();
        setOpen(!open);
    };
    var handleListClick = function (event) {
        var _a;
        var selectedIndex = event.target.getAttribute("data-index");
        if (selectedIndex) {
            var newSelectedIndex = parseInt(selectedIndex);
            if (((_a = props.children[newSelectedIndex]) === null || _a === void 0 ? void 0 : _a.props.value) !== null) {
                setSelection(newSelectedIndex);
                setOpen(false);
                var dropdownResult = {
                    name: props.name,
                    result: {
                        label: props.children[newSelectedIndex].props.label,
                        value: props.children[newSelectedIndex].props.value
                    }
                };
                if (props.clearErrors) {
                    props.clearErrors(props.name);
                }
                props.onChange(dropdownResult);
            }
            else {
                event.preventDefault();
            }
        }
        else {
            console.error("Attribute data-index not found on element:", event.target);
        }
    };
    var children = React.Children.map(props.children, function (child, index) {
        return React.cloneElement(child, {
            dataIndex: index
        });
    });
    var errorMessage = (_b = props.errors) === null || _b === void 0 ? void 0 : _b[props.name];
    var hasErrorMessage = (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.message) !== undefined;
    var dropdownField = props.withBorder ? "dropdown-field" : "dropdown-without-border";
    return (React.createElement("div", { className: "wrapper", "data-test": props.dataTest },
        React.createElement("div", { className: (0, classnames_1.default)({
                "dropdown-without-border": !props.withBorder,
                noHover: props.disabled,
                "style-dropdown-onfocus": open,
                "dropdown-error": hasErrorMessage
            }) },
            React.createElement("div", { className: dropdownField, onClick: handleClick },
                React.createElement("div", { className: "dropdown-flex-container" },
                    React.createElement("div", { className: "dropdown-select-container" },
                        React.createElement("div", { className: "dropdown-select-container-placeholder" }, props.withBorder ? (React.createElement("span", { className: (0, classnames_1.default)({ "placeholder-color": selectedLabel === props.placeholder }) }, selectedLabel)) : (React.createElement("b", { className: (0, classnames_1.default)({ "placeholder-color": props.disabled }) }, selectedLabel))),
                        React.createElement("div", { className: props.withBorder ? "dropdown-select-container-icon" : "un-styled-icons" },
                            React.createElement("i", { className: (0, classnames_1.default)({
                                    "icon-arrow-down": !open,
                                    "icon-arrow-up": open,
                                    "placeholder-color": props.disabled
                                }) }))),
                    React.createElement("div", { className: (0, classnames_1.default)({ "dropdown-options": open }) }, open && (React.createElement("div", null,
                        React.createElement("ul", { className: "datalayer", onClick: handleListClick }, children))))),
                hasErrorMessage && React.createElement("p", { className: "dropdown-error-label" }, errorMessage["message"]))),
        React.createElement("select", __assign({ className: "hiddenDropdown" }, register(name, { required: props.required }), { id: props.id, value: selection >= 0 ? children[selection].props.value : "", disabled: true }),
            React.createElement("option", { key: "dsbld", disabled: true, value: "" }, props.placeholder),
            children.map(function (child, index) {
                var _a = child.props, label = _a.label, value = _a.value;
                return (React.createElement("option", { disabled: props.disabled, "data-index": index, key: label, value: value }, label));
            }))));
};
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map